<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<table style="border-style:hidden;">
<caption><b>Table 3</b> Company Practices Before and After Lean and Green</caption>
<thead>
<tr>
<td align="left" style="border-style:hidden;" valign="top"></td>
<td align="left" style="border-style:hidden;" valign="top"><i>Before Lean and Green</i></td>
<td align="left" style="border-style:hidden;" valign="top"><i>After Lean and Green</i></td>
</tr>
</thead>
<tbody>
<tr>
<td align="left" style="border-style:hidden;" valign="top">Purchases</td>
<td align="left" style="border-style:hidden;" valign="top">Buying, storing, and managing more materials than really needed; paying higher bills for energy and water.</td>
<td align="left" style="border-style:hidden;" valign="top">Eliminating some purchases by designing processes and products that save steps, time, materials, and square footage; reducing other purchases by reusing existing materials.</td>
</tr>
<tr>
<td align="left" style="border-style:hidden;" valign="top">Disposal</td>
<td align="left" style="border-style:hidden;" valign="top">Paying freight and handling to dispose of materials that could have been avoided, reused, or recycled; obtaining and renewing time-consuming and expensive permits for disposing of hazardous materials.</td>
<td align="left" style="border-style:hidden;" valign="top">Paying less for disposal because much less is wasted; earning revenues through recycling.</td>
</tr>
<tr>
<td align="left" style="border-style:hidden;" valign="top">Transportation</td>
<td align="left" style="border-style:hidden;" valign="top">Paying more for transportation of incoming materials and hauling waste.</td>
<td align="left" style="border-style:hidden;" valign="top">Using less transportation by processing and packaging and reducing the quantity of materials flowing into and out of each site.</td>
</tr>
<tr>
<td align="left" style="border-style:hidden;" valign="top">Labor</td>
<td align="left" style="border-style:hidden;" valign="top">Excessive hiring to maintain wasteful procedures; watching absences and illness rise owing to exposure to unnecessary chemicals.</td>
<td align="left" style="border-style:hidden;" valign="top">Employees reporting fewer headaches and other illnesses and accidents; morale increases through the pride of working for a Lean and Green organization.</td>
</tr>
<tr>
<td align="left" style="border-style:hidden;" valign="top">Cleanup and Fines</td>
<td align="left" style="border-style:hidden;" valign="top">Cleaning up spills and paying penalties of millions of dollars; damaged reputations and even prison sentences.<a href="#/#ft1" id="fn1">*</a></td>
<td align="left" style="border-style:hidden;" valign="top">Incurring no costs for cleanup or fines; strengthening reputations by processing wastes properly.</td>
</tr>
<tr>
<td align="left" style="border-style:hidden;" valign="top">Revenues</td>
<td align="left" style="border-style:hidden;" valign="top">Losing market share to competitors who use material and energy efficiencies to offer less expensive products or products that have a smaller impact on the planet.</td>
<td align="left" style="border-style:hidden;" valign="top">Earning greater market share by introducing efficiencies that allow prices of products to be reduced; offering innovative products that reduce operational costs and meet customers’ increasing “green” standards.</td>
</tr>
<tr>
<td align="left" style="border-style:hidden;" valign="top">Bottom Line</td>
<td align="left" style="border-style:hidden;" valign="top">Higher expenses and lower revenues = LESS PROFIT</td>
<td align="left" style="border-style:hidden;" valign="top">Lower expenses and higher revenues = MORE PROFIT</td>
</tr>
</tbody>
</table>
<p><span><a href="#/#fn1" id="ft1">*</a>As occurred at one of the twenty organizations before it became Lean and Green.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap1t3.vue?71230db8